export const API_URL = process.env.VUE_APP_API_URL || 'https://docinway.com.mx/api/v1';
export const BASE_URL = process.env.VUE_APP_BASE_URL || 'https://docinway.com.mx';
export const PRIVATE_KEY = process.env.VUE_APP_PRIVATE_KEY;
export const PUBLIC_KEY = process.env.VUE_APP_PUBLIC_KEY;
export const ENV = process.env.NODE_ENV;
